import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },{
      path: '/home',
      name: 'home',
      component: () => import('@/views/home')
    },{
      path: '/textBoard',
      name: 'textBoard',
      component: () => import('@/views/textBoard')
    },{
      path: '/details',
      name: 'details',
      component: () => import('@/views/details')
    },{
      path: '/login',
      name: 'login',
      meta:{title:'登陆'},
      component: () => import('@/views/login')
    },{
      path: '/resetPassword',
      name: 'resetPassword',
      meta:{title:'重置密码'},
      component: () => import('@/views/resetPassword')
    },{
      path: '/vipText',
      name: 'vipText',
      meta:{title:'会员文本'},
      component: () => import('@/views/vipText')
    },{
      path: '/saveText',
      name: 'saveText',
      meta:{title:'保存文本'},
      component: () => import('@/views/saveText')
    },{
      path: '/textList',
      name: 'textList',
      meta:{title:'文本列表'},
      component: () => import('@/views/textList')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js